export default "__VITE_ASSET__bc247246__"